import { motion } from "framer-motion";

export const ClawMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="29" y="3" width="6" height="13" rx="2" fill="#D9DEE5" />
    <path d="M21 17h22l-3 6H24z" fill="#AEB6C2" />
    <path d="M20 23c-7 6-8 17-2 25M44 23c7 6 8 17 2 25" stroke="#D9DEE5" strokeWidth="3.5" fill="none" strokeLinecap="round" />
    <path d="M24 28l21 9-17 15z" fill="#FFD200" />
  </svg>
);

export const Wordmark = ({ size = "text-lg" }) => (
  <span className={`font-display font-black tracking-tight leading-none ${size}`}>
    <span className="text-gold-grad">PLAY</span>
    <span className="text-red-grad ml-1">TOYS</span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] text-[#FFD200] ${className}`}>{children}</p>
);
